import React from 'react';
import { motion } from 'framer-motion';
import { Check, Globe, Lock, Shield, Sparkles, Zap } from 'lucide-react';
import { Button } from './Button';
import { checkoutUrl, comboIncludes, ctaLabel, price, trackCheckout } from '../data/offer';
export function PricingSection() {
  return <section id="pricing" className="py-20 px-4 bg-base relative" data-id="element-173" data-mp="1j8p1xdh65dik">
      <div className="max-w-3xl mx-auto relative z-10" data-id="element-174" data-mp="1jb1qwalcgo54">
        <div className="text-center mb-10" data-id="element-175" data-mp="1n9ioo3ivkm9v">
          <h2 className="text-3xl md:text-5xl font-display font-extrabold mb-3 text-ink" data-id="element-176" data-mp="1ncmzvkurcia1">
            Your complete offer right now
          </h2>
          <p className="text-graphite text-sm md:text-base" data-id="element-177" data-mp="1x8gmxy63ru62">
            The complete coaching system + 5 strategic bonuses — ready for your next class.
          </p>
        </div>
        <motion.div initial={{
        opacity: 0,
        y: 24
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="bg-cream border-2 border-brand rounded-3xl p-1 relative shadow-[0_20px_50px_-30px_rgba(27,26,25,0.4)]" data-id="element-178" data-mp="2uyvi02kud5r">
          <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-brand text-white font-bold px-5 py-1.5 rounded-full uppercase tracking-wider text-xs flex items-center gap-1.5 whitespace-nowrap" data-id="element-179" data-mp="1hodfgaauprsu">
            <Sparkles size={14} aria-hidden="true" data-id="element-180" data-mp="17td4ldh8hxmc" /> Complete Package
          </div>
          <div className="bg-white rounded-[1.3rem] p-6 md:p-10 text-center" data-id="element-181" data-mp="25e7r4ojfpabi">
            <h3 className="text-2xl md:text-3xl font-display font-extrabold text-brand mb-3" data-id="element-182" data-mp="20g67a1e6p6yz">
              Ninja Coach Ready
            </h3>
            <p className="text-base text-graphite mb-6" data-id="element-183" data-mp="1vfjmqskdgtqa">
              Everything you need to train Ninja with confidence.
            </p>
            <ul className="text-left max-w-md mx-auto space-y-2 mb-6 bg-cream-light border border-silver-light rounded-xl p-4" data-id="element-184" data-mp="k1xzjcy2p27e">
              {comboIncludes.map(item => <li key={item} className="flex items-start gap-2 text-sm text-graphite" data-id="element-185" data-mp="g2yw5wrzpdi2">
                  <Check size={16} className="text-brand shrink-0 mt-0.5" aria-hidden="true" data-id="element-186" data-mp="hfosbjjapm46" />
                  <span data-id="element-187" data-mp="mes0hcuko8gd">{item}</span>
                </li>)}
            </ul>
            <div className="mb-6" data-id="element-188" data-mp="7jc1quj1rodn">
              <span className="text-lg text-graphite-light line-through block mb-1" data-id="element-189" data-mp="ciom98mg4jd2">
                {price.regular}
              </span>
              <div className="flex flex-wrap items-baseline justify-center gap-2" data-id="element-190" data-mp="3uvmqvsu6o0dk">
                <span className="text-2xl md:text-3xl text-ink" data-id="element-191" data-mp="3i8moa8tpwdh">TODAY:</span>
                <span className="text-4xl md:text-5xl font-bold text-brand" data-id="element-192" data-mp="3kyi1lk51josj">{price.today}</span>
              </div>
            </div>
            <Button href={checkoutUrl} target="_blank" onLinkClick={trackCheckout} className="w-full md:w-auto text-base md:text-lg py-4 px-8 mb-5" data-id="element-193" data-mp="3pymnjpopxbq5">
              {ctaLabel}
            </Button>
            <div className="flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs text-graphite-light mb-4" data-id="element-194" data-mp="2xb3g16bbyzlm">
              <span className="flex items-center gap-1.5" data-id="element-195" data-mp="2sca25cs4t6kx">
                <Lock size={12} className="text-brand" aria-hidden="true" data-id="element-196" data-mp="2sduwp2eg4pis" /> Secure payment
              </span>
              <span className="flex items-center gap-1.5" data-id="element-197" data-mp="369f1ktxcb777">
                <Zap size={12} className="text-brand" aria-hidden="true" data-id="element-198" data-mp="31bx2rwd1e8cx" /> Immediate access
              </span>
              <span className="flex items-center gap-1.5" data-id="element-199" data-mp="3g8edqmhbdkyy">
                <Shield size={12} className="text-brand" aria-hidden="true" data-id="element-200" data-mp="3bbe6w9cn4e6s" /> 7-day guarantee
              </span>
            </div>
            <div className="bg-cream border border-silver-light rounded-xl p-3 max-w-md mx-auto flex items-start gap-2.5 text-left" data-id="element-201" data-mp="3p0zk133rdz6w">
              <Globe className="text-brand shrink-0 mt-0.5" size={14} aria-hidden="true" data-id="element-202" data-mp="3l31rpreoywza" />
              <p className="text-[11px] text-graphite-light leading-snug" data-id="element-203" data-mp="2syjlx38sr8k">
                Pay in your local currency. The amount adjusts automatically based on your country.
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}